import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateQuoteProduct as UpdateQuoteProductMutation,
    UpdateQuoteProductVariables,
    QuoteProductsUpdateInput,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../../../apollo-client';

import SALES_DOCUMENT_TEMPLATE_FRAGMENT from '../fragments/sales-document-template-fragment.graphql';
import UPDATE_QUOTE_TEMPLATE_PRODUCT from '../mutations/update-quote-template-product.graphql';

export const useUpdateQuoteTemplateProduct = (): {
    updateQuoteTemplateProduct: (input: QuoteProductsUpdateInput) => Promise<any>;
} => {
    const [updateQuoteTemplateProduct, {loading, error}] = useMutation<
        UpdateQuoteProductMutation,
        UpdateQuoteProductVariables
    >(UPDATE_QUOTE_TEMPLATE_PRODUCT);

    return {
        updateQuoteTemplateProduct: (input: QuoteProductsUpdateInput) => {
            return updateQuoteTemplateProduct({
                variables: {input},
                // @ts-expect-error
                optimisticResponse: () => {
                    const cachedSalesDocument = nutApolloClient.readFragment({
                        id: input.id,
                        fragment: SALES_DOCUMENT_TEMPLATE_FRAGMENT,
                        fragmentName: 'SalesDocumentTemplateFragment',
                    });

                    if (cachedSalesDocument) {
                        return {
                            __typename: 'Mutation',
                            quoteProductsUpdate: {
                                __typename: 'QuoteProductsUpdatePayload',
                                salesDocument: {
                                    ...cachedSalesDocument,
                                    isSkuShown: input.isSkuShown,
                                    isTermShown: input.isTermShown,
                                    isDiscountShown: input.isDiscountShown,
                                },
                            },
                        };
                    }

                    return {};
                },
            });
        },

        // @ts-expect-error
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
